import React from "react";

import {
  Stack,
} from '@material-ui/core';
import { useDialog } from "../../components/DialogProvider";
import { User } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { actions } from "../../services/users";

import LoadingButton from "@material-ui/lab/LoadingButton";



interface Props {
  user: User
}

const UserActions: React.FC<Props> = ({ user }) => {
  const dialog = useDialog();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.users);





  const onDelete = () => {
    dialog.confirm({
      title: `Are you sure, you want to delete ${user.firstName} ${user.lastName} ?`,
      subtitle: `This can't be undone`,
      onConfirm: () => {
        dispatch(actions.deleteUser(user.id));
      }
    });
  }


  const onDisable = () => {
    dialog.confirm({
      title: `Are you sure, you want to disable ${user.firstName} ${user.lastName} ?`,
      subtitle: `This can't be undone`,
      onConfirm: () => {
        dispatch(actions.disableUser(user.id));
      }
    });
  }


  return (
    <Stack spacing={1} direction="column" alignItems="center">
      <LoadingButton
        disabled={user.status !== 'active' || state.disablePending === user.id}
        onClick={onDelete}
        loading={state.deletePending === user.id}
      >
        Delete
      </LoadingButton>
      <LoadingButton
        disabled={user.status !== 'active' || state.deletePending === user.id}
        onClick={onDisable}
        loading={state.disablePending === user.id}
      >
        Disable
      </LoadingButton>
    </Stack>
  );
};

export default UserActions;